import React from 'react';
import properties from '../../../modules/ajio-util/properties';

class CpImage extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const productsAdditionalInfo = this.props.productsAdditionalInfo;
    const cpImage = productsAdditionalInfo.imageURL;
    const cpTitle = productsAdditionalInfo.title;

    return (
      <div className="cp-imagecontainer" onClick={this.props.onClick}>
        {cpTitle ? <p>{cpTitle}</p> : null}
        {cpImage ? (
          <div className="cp-image">
            <img src={`${cpImage}`} alt={cpTitle} title={cpTitle} />
          </div>
        ) : null}
      </div>
    );
  }
}

export default CpImage;
